function upsert(selector, create, attr, value) {
  let el = document.head.querySelector(selector);
  if (value == null) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

function metaTag(attr, name) {
  return () => {
    const el = document.createElement('meta');
    el.setAttribute(attr, name);
    return el;
  };
}

function setMeta(attr, name, content) {
  upsert(`meta[${attr}="${name}"]`, metaTag(attr, name), 'content', content);
}

/**
 * Writes the route's SEO tags into <head>. Title and description are only
 * touched when given, so pages that set their own (invitations, privacy) keep them.
 *
 * @param {{ title?: string, description?: string, canonical?: string|null, indexable: boolean }} meta
 */
export function applyHeadMeta({ title, description, canonical = null, indexable }) {
  if (title) {
    document.title = title;
    setMeta('property', 'og:title', title);
    setMeta('name', 'twitter:title', title);
  }
  if (description) {
    setMeta('name', 'description', description);
    setMeta('property', 'og:description', description);
    setMeta('name', 'twitter:description', description);
  }
  const url = indexable ? canonical : null;
  upsert('link[rel="canonical"]', () => {
    const el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    return el;
  }, 'href', url);
  setMeta('property', 'og:url', url);
  setMeta('name', 'robots', indexable ? null : 'noindex');
}
